import { useState, useEffect, useRef, useMemo } from "react"
import { FaFileExport } from "react-icons/fa"
import { useNavigate, useLocation } from "react-router-dom"
import { toast } from 'react-toastify'
import Server from "../../Shared/Server"
import Spinner from '../../Shared/Spinner'
import { months_list } from "../../Shared/List"
import {AgGridReact} from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

const VendorStatement = () => {
    const [statement, setStatement] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [title, setTitle] = useState('');
    const gridRef = useRef();

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (location.state){
            const {payload} = location.state
            const date = new Date().toISOString().slice(0, 10)
            setTitle(`${payload.name}, Statement Report as ${date}`)
            getStatement({public_id: payload.public_id})
        }
        
        
    }, [])
    let gridApi

    const onGridReady=(params)=>{
        gridApi=params.api
    }
      const onExportClick=()=>{
        gridApi.exportDataAsCsv()
    }

    const getStatement = async (payload) => {
        setIsLoading(true)
        try {
            const response = await Server.get(`/vendors/statement?public_id=${payload.public_id}`)
            setStatement(response?.data)
            setIsLoading(false) 
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                localStorage.removeItem('user')
                navigate('/login')
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error(error.response.data)
            }
        }
    }

    const defaultColDef = useMemo(() => {
        return {
            filterParams: {
                buttons: []
            }
        };
    }, []);

    const onFirstDataRendered = (params) => {
        params.api.autoSizeAllColumns();
    }

    const onGridSizeChanged = (params) => {
        params.api.autoSizeAllColumns();
    }

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="row">
            <div className="col-md-12">
                <button onClick={()=>onExportClick()} className="btn btn-success mb-2" style={{float: 'right'}}><FaFileExport/> &nbsp;Export</button>
            </div>
        </div>
        <div className="card">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">{title}</h3>
            </div>
            <div className="card-body">
            <div className="row">
                <div className="col-md-12">
                    <div className="ag-theme-alpine responsive-aggrid" style={{ height: 400, width: '100%' }}>
                        <AgGridReact
                            defaultColDef={defaultColDef}
                            onFirstDataRendered={onFirstDataRendered}
                            onGridSizeChanged={onGridSizeChanged}
                            onGridReady={onGridReady}

                            suppressMenuHide={true}
                            
                            rowData={statement}
                            domLayout={"normal"}
                            rowSelection={"multiple"}
                    
                            animateRows={true}
                        
                            pagination={false}
                        
                            resizable={true}
                            enableCellTextSelection={true}
                            suppressCellFocus={true}
                        
                        
                            ref={gridRef}
                            groupIncludeTotalFooter={false}
                            groupIncludeFooter={false}
                            columnDefs={[
                            {
                                headerName: "#",
                                filter: false,
                                maxWidth: 70,
                                sortable: true,
                                valueFormatter: function (params) {
                                if (isNaN(params.node.id)) {
                                    return "";
                                }
                                return `${Number(params.node.rowIndex) + 1}`;
                                },
                            },
                            
                            {
                                headerName: "Date",
                                field: "date",
                                sortable: true,
                                filter: 'agDateColumnFilter',
                                filterParams: {
                                    comparator: (filterDate, cellValue) => {
                                      const cellDate = new Date(cellValue);
                                      cellDate.setHours(0, 0, 0, 0);
                                      filterDate.setHours(0, 0, 0, 0);
                            
                                      if (cellDate < filterDate) return -1;
                                      if (cellDate > filterDate) return 1;
                                      return 0;
                                    },
                                },
                            },
                            {
                                headerName: "User",
                                field: "user",
                                sortable: true,
                                filter: true,
                            },
                            {
                                headerName: "Remark",
                                field: "remark",
                                sortable: true,
                                filter: true,
                            },
                            {
                                headerName: "Credit",
                                field: "credit",
                                sortable: true,
                                filter: 'agNumberColumnFilter',
                            },
                            {
                                headerName: "debit",
                                field: "debit",
                                sortable: true,
                                filter: 'agNumberColumnFilter',
                            },
                            {
                                headerName: "Balance",
                                field: "balance",
                                sortable: true,
                                filter: 'agNumberColumnFilter',
                            },
                            ]}
                        ></AgGridReact>{" "}
                    </div>
                </div>
            </div>
        </div>
    </div>
      <br/>
    </>
  )
}

export default VendorStatement
